var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragAccepted = function SvgDragAccepted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 94,
    viewBox: "0 0 73 94",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M184.594 73.697c.776.783 1.406 2.315 1.406 3.422v59.829c0 5.552-4.477 10.052-9.997 10.052h-53.006c-5.521 0-9.997-4.502-9.997-10.049V63.05c0-5.55 4.475-10.049 9.995-10.049h39.05c1.109 0 2.641.638 3.414 1.417l19.135 19.28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 -53)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3080DF",
    strokeWidth: 3,
    d: "M183.529 74.754c.497.501.971 1.654.971 2.365v59.829c0 4.724-3.807 8.552-8.497 8.552h-53.006c-4.69 0-8.497-3.828-8.497-8.549V63.05c0-4.724 3.805-8.549 8.495-8.549h39.05c.708 0 1.857.477 2.35.974l19.134 19.28z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3080DF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.616 59.386c.754.812 1.968.82 2.73 0l8.772-9.448c1.507-1.622.94-2.938-1.263-2.938H28.107c-2.204 0-2.77 1.316-1.263 2.938l8.772 9.448zM33 36.496c0-.826.668-1.496 1.505-1.496h4.99c.831 0 1.505.68 1.505 1.496V47h-8V36.496z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#3080DF",
    strokeWidth: 3,
    d: "M71.293 22.293c.39.39.268.707-.295.707H60.002C54.478 23 50 18.521 50 12.998V2.002c0-.553.311-.691.707-.295l20.586 20.586z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragAccepted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag-accepted.724b30f440ae31096de38d61c12dd296.svg";